<!---图片验证码-->
<template>
  <div
    class="dlrLayer slideMiddle_in fn-hide"
    id="liimgValidCodeSMS"
    style="z-index: 9999"
  >
    <div class="dlrLayer-middle">
      <div class="mailmSucc">
        <i class="mailmSucc-close" id="Yzm" @click="close"></i>
        <div class="mailmSucc-second">
          <h4 class="secondName">请输入验证码</h4>
          <div class="secondForm">
            <ul class="dlrFormul">
              <li>
                <div class="dlrFormul-card">
                  <p class="dlrFormul-card-text">
                    <input
                      type="text"
                      class="dlrFormul-inpText"
                      placeholder="请输入验证码"
                      id="SMSCode2"
                      maxlength="10"
                    />
                  </p>
                </div>
                <p class="dlrFormul-other">
                  <span class="dlrFormul-other-yzmpic"
                    ><img id="imgValidCodeSMS" alt=""
                  /></span>
                  <i
                    id="imgValidCodeSMSchangeCode"
                    class="dlrFormul-icon iconRefresh"
                  ></i>
                </p>
              </li>
            </ul>
            <p class="text-error" id="yzmerror"></p>
          </div>
          <div class="mailbForm-link">
            <span class="linkBtn" id="btnSendCodeok">
              <em>
                <b class="btnName">确认</b>
              </em>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask" @click="close"></div>
  </div>
</template>
<script>
export default {
  methods: {
    close: function () {
      document.getElementById('liimgValidCodeSMS').classList.add('fn-hide');
    }
  }
};
</script>
<style scoped lang="scss">
.text-error {
  clear: both;
  text-align: left;
  font-size: 0.75rem;
  color: #ff465a;
  padding-top: 0.375rem;
}
</style>
